import React from "react";
import "./Footer.css"
export default function Footer(props) {
  return (
    <div className={props.mode}>
      <div className="footer">
      <p> Copyright &copy; 2024 Ganesh Kumbhar</p>
      </div>
    </div>
  )
}